import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllLabelGroupDataService = async (
  pageNumber,
  pageSize,
  access_token,
  debouncedSearch = ""
) => {
  try {
    return axios.get(
      `${api}/LabelGroup/LabelGroupDataPagination?pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      }
    );
  } catch (err) {
    return err;
  }
};

export const fetchCountriesService = async (access_token) => {
  try {
    return axios.get(`${api}/LabelGroup/ActiveCountriesList`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const addLabelGroupService = async (access_token, data) => {
  try {
    return axios.post(`${api}/LabelGroup/AddLabelGroup`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchLabelGroupByIdService = async (access_token, id) => {
  try {
    return axios.get(`${api}/LabelGroup/GetById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateLabelGroupService = async (access_token, data, id) => {
  try {
    return axios.post(`${api}/LabelGroup/UpdateLabelGroup?Id=${id}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};
